export type AuthEvent = 'session-cleared' | 'permission-denied';

type Listener = () => void;

const listeners: Record<AuthEvent, Set<Listener>> = {
  'session-cleared': new Set<Listener>(),
  'permission-denied': new Set<Listener>(),
};

export function emitAuthEvent(event: AuthEvent): void {
  const eventListeners = listeners[event];

  eventListeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error(`[auth-events] listener for ${event} failed`, error);
    }
  });
}

export function subscribeAuthEvent(event: AuthEvent, listener: Listener): () => void {
  const eventListeners = listeners[event];
  eventListeners.add(listener);

  return () => {
    eventListeners.delete(listener);
  };
}
